import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '上游活动示例页';

const route: RouteConfig = {
  path: '/demo',
  name: 'shangyou-activity-demo',
  component: () => import('./RouterHolder.vue'),
  redirect: '/demo/feature-list',
  meta: {
    title: PAGE_TITLE,
    rank: 1,
  },
  children: [
    {
      name: 'shangyou-activity-home-page',
      path: 'feature-list',
      component: () => import('./Home.vue'),
      meta: {
        title: `${PAGE_TITLE}--功能展示`,
        rank: 2,
      },
    },
    {
      name: 'shangyou-activity-demo-page-cache',
      path: 'page-cache',
      component: () => import('./subpages/PageCache.vue'),
      meta: {
        title: `${PAGE_TITLE}--页面缓存`,
        rank: 2,
      },
    },
    {
      name: 'shangyou-activity-demo-detail-page',
      path: 'detail',
      component: () => import('./subpages/Detail.vue'),
      meta: {
        title: `${PAGE_TITLE}--详情页`,
        rank: 3,
      },
    },
    {
      name: 'shangyou-activity-demo-upload-page',
      path: 'upload',
      component: () => import('./subpages/MediaUpload.vue'),
      meta: {
        title: `${PAGE_TITLE}--媒体上传`,
        rank: 3,
      },
    },
    {
      name: 'shangyou-activity-demo-rich-text-editor-page',
      path: 'rich-text-editor',
      component: () => import('./subpages/RichTextEditor.vue'),
      meta: {
        title: `${PAGE_TITLE}--富文本编辑`,
        rank: 3,
      },
    },
    {
      name: 'shangyou-activity-vote-page',
      path: 'make-vote',
      component: () => import('./subpages/MakeVote.vue'),
      meta: {
        title: `${PAGE_TITLE}--投票`,
        rank: 3,
      },
    },
    {
      name: 'live-comments',
      path: 'live-comments',
      component: () => import('./subpages/LiveComments.vue'),
      meta: {
        title: '测试--直播评论',
        rank: 3,
        customWeChatAuth: true,
      },
    },
    {
      name: 'a-paragraph-can-fold',
      path: 'a-paragraph-can-fold',
      component: () => import('./subpages/AParagraphCanFold.vue'),
      meta: {
        title: '可展开收起段落',
        rank: 3,
        customWeChatAuth: true,
      },
    },
    {
      name: 'form-list',
      path: 'form-list',
      component: () => import('./subpages/FormList.vue'),
      meta: {
        title: '表单页面',
        rank: 3,
        customWeChatAuth: true,
      },
    },
    {
      name: 'list-page',
      path: 'list-page',
      component: () => import('./subpages/ListPage.vue'),
      meta: {
        title: '列表页面',
        rank: 2,
        customWeChatAuth: true,
      },
    },
    {
      name: 'activity-list',
      path: 'activity-list',
      component: () => import('./subpages/ActivityList.vue'),
      meta: {
        title: '活动列表',
        rank: 2,
        customWeChatAuth: true,
      },
    },
    {
      name: 'audio',
      path: 'audio',
      component: () => import('./subpages/AudioUsage.vue'),
      meta: {
        title: '音频',
        rank: 2,
        customWeChatAuth: true,
      },
    },
  ],
};

export default route;
